<!--
	作者：masonchen
	时间：2017-04-10
	描述：轨迹回放页面
-->
<template>
	<div class="tabBox" style="overflow:hidden;">
		<track-map></track-map>
		<vehicle-list></vehicle-list>
		<div style="height:300px; position:absolute;right:30px;bottom:250px;" v-if="calendar">
			<Calendar></Calendar>
		</div>
		<vehicle-axis v-if="showInfoComp"></vehicle-axis>
		<vehicle-info v-if="showInfoComp"></vehicle-info>
		<vehicle-play v-if="showInfoComp"></vehicle-play>
		<!--行车速度图示开始-->
	  	<div class="map_graphic"></div>
		<!--页面tab弹框组件开始-->				
		<tab-modal ref="modal1" size="small" title="温馨提示" v-on:cancel="closeModal">
			<p v-text="tipContent"></p>	
			<div slot="footer">
				<button v-if="showWithdraw" class="btn btn-primary" @click="withdrawBtn">取消</button>
				<button class="btn btn-primary" @click="confirmBtn">确定</button>
			</div>
		</tab-modal>
		<!--页面tab弹框组件结束-->
	</div>
</template>
<script>
	import TabModal from 'components/common/TabModal'
	import TrackMap from 'components/common/Map/TrackMap.vue'
	import {mapState} from 'vuex'
	import VehicleAxis from './VehicleAxis'
	import Calendar from 'components/common/Calendar/Calendar'
	import VehicleList from './VehicleList'
	import VehicleInfo from './VehicleInfo'
	import VehiclePlay from './VehiclePlay'
	export default{
		components: {
			TabModal,
			TrackMap,
			VehicleList,
			VehicleAxis,
			VehicleInfo,
			VehiclePlay,
			Calendar
		},
		computed:mapState({
			showModal:state => state.vehicle.showModal,
			showInfoComp:state => state.vehicle.showInfoComp,
			calendar:state => state.vehicle.calendar,
			tipContent:state => state.vehicle.tipContent,
			showWithdraw:state => state.vehicle.showWithdraw
		}),
		watch:{
			showModal:function(val){
				if(val){
					this.$refs.modal1.open()
				}else{
					this.$refs.modal1.close()
				}
			}
		},
		methods:{
			confirmBtn(){//确定操作
				if(this.showWithdraw){//确认弹框--清空队列确认
					this.$store.dispatch('deleteAll').then(()=>{
						this.$store.dispatch('getTraces',1)
					})
				}
				this.$refs.modal1.close();
				this.$store.dispatch('hideModal')
			},
			withdrawBtn(){//取消操作
				this.closeModal()
			},
			closeModal(){//点X按钮关闭弹框
				this.$refs.modal1.close();
				this.$store.dispatch('hideModal')
			} 
		},
		beforeDestroy(){
			this.$store.commit('setOpenFrom',0)
		}
	}
</script>
<style>
	.map_graphic{background:url(../../../assets/project/images/map/map_graphic02.png) ; width:55px; height:110px; background-size:100%; position:absolute; bottom:163px; left:248px;}
</style>


// WEBPACK FOOTER //
// PageTraceVehicle.vue?0f9cf8c6